export default {
  gsynPattern: /:gsyn\((?:[^)(]+)\)/g,
  synPattern: /:syn\((?:[^)(]+)\)/g,

  globalSynonymsInText(text) {
    return text.match(this.gsynPattern) || [];
  },
  synonymsInText(text) {
    return text.match(this.synPattern) || [];
  },
  getGsynName(gsyn) {
    const withoutFormats = this.removeFormatting(gsyn);
    return withoutFormats.substring(withoutFormats.indexOf("(") + 1, withoutFormats.lastIndexOf(")"));
  },

  removeFormatting(gsyn) {
    return gsyn && gsyn.indexOf("|") > -1 ? gsyn.substring(0, gsyn.indexOf("|")) + ")" : gsyn;
  }
};
